(function () {

  'use strict';

  function pxGroupQueues(
    GroupListService, PrintQueueListPaging, DEFAULT_ITEMS_PER_PAGE, $timeout, $rootScope
  ) {
    return {
      restrict: 'EA',
      scope: {
        group: '=group',
        tenant: '=tenant',
        me: '=me',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/groupProperties/groupQueues/groupQueues.template.html',
      link: function (scope) {

        scope.printQueueListPaging = new PrintQueueListPaging();
        scope.printQueueListPaging.page = 0;
        scope.printQueueListPaging.pageSize = DEFAULT_ITEMS_PER_PAGE;
        scope.printQueueListPaging.direction = 'ASC';
        scope.printQueueListPaging.sort = 'QUEUE_NAME';
        scope.printQueueListPaging.groupFilterMode = 'ATTACHED_TO_GROUPS';

        scope.printQueueList = null;
        scope.printQueuePage = null;
        scope.printQueueContainer = null;

        (function () {
          getPrintQueues();
        })();

        function getPrintQueues() {
          const url = scope.group.info._links['px:queues'].href;
          scope.printQueueListPaging.groups = [scope.group.info._links.self.href];
          scope.printQueueListPaging.networks = scope.me.permissions.TENANT_ADMIN ? null : scope.me.networks;
          GroupListService.getGroupPrintQueues(url, scope.printQueueListPaging)
            .then(function (response) {
              scope.printQueueContainer = response;
              scope.printQueueList = response.list;
              scope.printQueuePage = response.page;
              checkQueueuGroupsState();
            })
            .catch(function () {
            });
        }

        scope.getNextPageOfPrintQueues = function () {
          if (scope.printQueueListPaging.page + 1 < scope.printQueuePage.totalPages) {
            scope.printQueueListPaging.page++;
            getPrintQueues();
          }
        };

        scope.getPreviousPageOfPrintQueues = function () {
          if (scope.printQueueListPaging.page > 0) {
            scope.printQueueListPaging.page--;
            getPrintQueues();
          }
        };

        function checkQueueuGroupsState() {
          angular.forEach(scope.printQueueList, function (queue) {

            queue.groupSetting = {
              autoInstallGroup: false,
              defaultForGroup: false,
              group: false
            };

            const autoInstallGroupLink = queue.info._links['px:autoInstallGroup'];
            if (autoInstallGroupLink) {
              if (angular.isArray(autoInstallGroupLink)) {
                queue.groupSetting.autoInstallGroup = autoInstallGroupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (autoInstallGroupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.autoInstallGroup = true;
                }
              }
            }

            const defaultForGroupLink = queue.info._links['px:defaultForGroup'];
            if (defaultForGroupLink) {
              if (angular.isArray(defaultForGroupLink)) {
                queue.groupSetting.defaultForGroup = defaultForGroupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (defaultForGroupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.defaultForGroup = true;
                }
              }
            }

            const groupLink = queue.info._links['px:group'];
            if (groupLink) {
              if (angular.isArray(groupLink)) {
                queue.groupSetting.group = groupLink.some(function (link) {
                  return link.href === scope.group.info._links.self.href;
                });
              } else {
                if (groupLink.href === scope.group.info._links.self.href) {
                  queue.groupSetting.group = true;
                }
              }
            }

          });
        }

        scope.openContextMenu = function (event, context, menuOption) {
          $timeout(function () {
            scope.selectedContextMenuItem = menuOption;
            scope.contextPosition = { left: event.clientX, top: event.clientY };
            scope.context = context;
            scope.resource = {
              tenant: scope.tenant,
              me: scope.me,
              groupQueues: scope.printQueueList,
              group: scope.group
            };
          });

        };

        scope.closeAllMenues = function () {
          scope.selectedContextMenuItem  =  null;
          scope.contextPosition = null;
          scope.context = null;
        };

        scope.showTooltip = function (showTip, position, tooltipScope, context) {
          if (showTip) {
            switch (tooltipScope) {
              case 'queue':
                queueTooltip(position, context);
                break;
            }
          } else {
            scope.clearTooltip();
          }
        };

        function queueTooltip(position, queue) {
          scope.tooltipContent = {
            title: 'Queue',
            type: 'queueDetails',
            queue: queue.info
          };
          scope.tooltipObject = {
            position: { left: position.startX - 15, top: position.startY + 20 },
            contextMenu: false
          };
        }

        scope.clearTooltip = function () {
          scope.tooltipContent = null;
          scope.tooltipObject = null;
        };

        const deregisterUpdateGroupQueuesListener = $rootScope.$on('UPDATE_GROUP_QUEUES', function () {
          getPrintQueues();
        });

        scope.$on('$destroy', function () {
          deregisterUpdateGroupQueuesListener();
        });

      }
    };
  }

  pxGroupQueues.$inject = ['GroupListService', 'PrintQueueListPaging', 'DEFAULT_ITEMS_PER_PAGE', '$timeout', '$rootScope'];

  angular
    .module('printix-admin')
    .directive('pxGroupQueues', pxGroupQueues);

})();
